<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <span class="nav-lspan">当前对账状态：<span style="color: green;">{{ this.resDate.checkStatus | DictionaryFilter("CHECK_STATUS") }}</span></span>
      <!-- 按钮 -->
      <div class="nav_but">
        <a-button class="bottom-button" type="primary"  @click="handleConfirm" style="margin-right: 10px;" v-if="this.$route.query.type == 1" :loading="loading">确认对账</a-button>
        <a-button class="bottom-button" type="primary" ghost @click="cancle" >返回</a-button>
      </div>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">交易信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{1}}
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one" style="margin-top: 20px;">
          <div class="form_title">对账记录</div>
        </div>

        <!-- 表单2 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_gridTwo.field"
          :data-source="relevanceBatch_gridTwo.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_gridTwo.height,x:relevanceBatch_gridTwo.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{1}}
          </span>
          <!-- 退款金额（固定0.00） -->
          <span slot="refundAmount" slot-scope="text, record, index">
            0.00
          </span>
        </a-table>
        
      </div>
    </div>
  </div>
</template>
    
<script>
import {
  queryTradeById,
  tradeByHand
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  name: "FtsTrustWebAddInvestment",
  components: {
  },
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 55,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "交易编号",
            align: "center",
            width: 150,
            dataIndex: "tradeNo",
            ellipsis: true,
          },
          {
            title: "交易商品名称",
            align: "center",
            width: 245,
            dataIndex: "goodName",
            ellipsis: true,
          },
          {
            title: "交易金额",
            align: "center",
            width: 100,
            dataIndex: "tradeAmount",
            ellipsis: true,
          },
          {
            title: "手续费金额",
            colSpan: 1,
            width: 100,
            dataIndex: "serviceAmount",
            align: "center",
            ellipsis: true,
          },
          {
            title: "代金券金额",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "voucherAmount",
          },
          {
            title: "交易状态",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "tradeStatus",
          },
          {
            title: "交易时间",
            colSpan: 1,
            align: "center",
            width: 150,
            ellipsis: true,
            dataIndex: "tradeTime",
          },
          {
            title: "交易类型",
            colSpan: 1,
            align: "center",
            width: 140,
            ellipsis: true,
            dataIndex: "tradeType",
            scopedSlots: {
              customRender: "tradeType",
            },
          },
        ]
      },

      relevanceBatch_gridTwo: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 40,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "交易单号",
            align: "center",
            width: 260,
            dataIndex: "tradeNumber",
            ellipsis: true,
          },
          {
            title: "入账金额",
            align: "center",
            width: 80,
            dataIndex: "recordAmount",
            ellipsis: true,
          },
          {
            title: "退款金额",
            align: "center",
            width: 80,
            dataIndex: "refundAmount",
            ellipsis: true,
            scopedSlots: {
              customRender: "refundAmount",
            },
          },
          {
            title: "手续费返还",
            colSpan: 1,
            width: 90,
            dataIndex: "serviceAmount",
            align: "center",
            ellipsis: true,
          },
          {
            title: "支付渠道",
            colSpan: 1,
            align: "center",
            width: 80,
            ellipsis: true,
            dataIndex: "payChannel",
          },
          {
            title: "结算币种",
            colSpan: 1,
            align: "center",
            width: 80,
            ellipsis: true,
            dataIndex: "currencyType",
          },
          {
            title: "账单日期",
            colSpan: 1,
            align: "center",
            width: 110,
            ellipsis: true,
            dataIndex: "billDate",
          },
        ]
      },

      //响应数据
      resDate: {},
      loading:false,


    };
  },
  mounted() {
  // 获取字典
  DictionaryService.getAllNeedDic(["CHECK_STATUS"]).then((res) => {
      //查询
      this.queryList();
  }); 
  this.relevanceBatch_grid.width = 0;
  this.relevanceBatch_grid.field.map(item => {
    this.relevanceBatch_grid.width += item.width;
  });

  this.relevanceBatch_gridTwo.width = 0;
  this.relevanceBatch_gridTwo.field.map(item => {
    this.relevanceBatch_gridTwo.width += item.width;
  });
  },
  methods: {
    //查询接口
    queryList() {
      queryTradeById({
        id: this.$route.query.id
      }).then(res => {
        this.resDate = res.content;
        let obj = [];
        obj.push(res.content)
        this.relevanceBatch_grid.row = obj;
        this.relevanceBatch_gridTwo.row = obj;
        // if (res.content.rows && res.content.rows.length) {
        //   this.relevanceBatch_grid.row = res.content.rows;
        //   this.total = res.content.page.totalRows;
        // } else {
        //   this.relevanceBatch_grid.row = [];
        //   this.total = 0;
        // }
      });
    },
    // 取消按钮
    cancle() {
      this.$router.go(-1);
    },
    //确认对账
    handleConfirm() {
      this.loading = true;
      tradeByHand({
        orderNo : this.$route.query.orderNo
      }).then(
      (res) => {
        if (res.code == '0000') {
          this.loading = false;
          this.$message.success('手工对账成功！');
          this.$router.go(-1);
        }
      },
      (err) => {
        this.loading = false;
        this.$message.error('手工对账失败！')
      });
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    width: 100%;
    height: 60px;
    background: #fff;
    z-index: 100;
    display: flex;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 2px;
    .nav-lspan {
      margin-left: 100px;
      font-size: 16px;
      float: left;
      margin: 8px 8px 8px 30px;
      color: black;
      flex: 1;
    }
    .nav_but{
      margin-right: 30px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 88%;
    background: #fff;
    .body-content {
      padding: 15px 20px 15px 20px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}
</style>